import { Spacer } from "@cd2/components/build/es6"
import React from "react"
import { ConfirmCancelDialogue } from "../Components/ConfirmCancelDialogue"
import { KeyValueList } from "../Components/KeyValueList"
import { HoverProductLoader } from "../hoverLoaders/HoverProductLoader"
import { IRecord } from "../types/schema"
import { dublCorkBranchId } from "../../shared/constants"

export function useProductAlternative() {
  return async (productId: string) => {
    const result = await checkAlternativeProduct(productId)
    return result
  }
}

export function ConfirmAlternateProductModal({
  onResolve,
  data,
}: {
  data: {
    original: IProduct
    alternative: IProduct
  }
  onResolve: (product: Omit<IProduct, "alternativeProduct">) => any
}) {
  return (
    <ConfirmCancelDialogue
      heading="An alternative product has been selected as a preferable alternative."
      onConfirm={() => onResolve(data.alternative)}
      onCancel={() => onResolve(data.original)}
      body={
        <React.Fragment>
          <Spacer />
          <KeyValueList
            data={[
              {
                label: "Alternative Product",
                value: <HoverProductLoader id={data.alternative.id} />,
              },
              {
                label: "Original Product",
                value: <HoverProductLoader id={data.original.id} />,
              },
            ]}
          />
        </React.Fragment>
      }
      buttonOpts={{
        confirm: { children: "Use alternative product" },
        cancel: { children: "Use original product" },
      }}
      isOpen
    />
  )
}

type IProduct = IRecord<"products">

async function checkAlternativeProduct(productId: string) {
  const record = await window.skeem.fetch2<IProduct & { alternative?: IProduct }>({
    first: {
      name: "products",
      attributes: [alternativeProductAttribute],
      filter: { matches: { id: productId } },
    },
  })
  console.log(record)
  const product = { ...record, alternative: undefined }
  let alternative = record.alternative

  // This fixes a skeem bug where it returns the id as a string instead of an object
  if (typeof alternative === "string") {
    alternative = { id: alternative } as IProduct
  }

  return { original: product as IProduct, alternative }
}

export const alternativeProductAttribute = {
  as: "alternative",
  value: {
    with: {
      data: {
        branchId: { path: ["branch", "id"] },
      },
      run: {
        if: [
          { eq: [{ var: "branchId" }, { value: dublCorkBranchId }] },
          {
            first: {
              path: [
                "product_master",
                "mandatoryAlternativeProductIreland",
                {
                  name: "products",
                  filter: { eq: [{ path: ["branch", "id"] }, { var: "branchId" }] },
                },
              ],
            },
          },
          {
            first: {
              path: [
                "product_master",
                "mandatoryAlternativeProduct",
                {
                  name: "products",
                  filter: { eq: [{ path: ["branch", "id"] }, { var: "branchId" }] },
                },
              ],
            },
          },
        ],
      },
    },
  },
}
